import { PAYROLL_STATUS, PAYROLL_STATUS_LABELS } from "../../../services/payrollPeriodic.js";
import { formatDisplayPeriod } from "../../../Helper/functionHelper.js";
import UserInfoCell from "../../../components/common/UserInfoCell.jsx";


const STATUS_COLORS = {
  [PAYROLL_STATUS.DRAFT]: "#6c757d",
  [PAYROLL_STATUS.GENERATED]: "#2f6fed",
  [PAYROLL_STATUS.APPROVED]: "#219653",
  [PAYROLL_STATUS.REJECTED]: "#b83227",
};

const UNIT_LABEL = {
  DAILY: "days",
  WEEKLY: "days",
  BIWEEKLY: "days",
  HOURLY: "hrs",
};

const StatusBadge = ({ status }) => (
  <span
    className="d-inline-flex align-items-center justify-content-center"
    style={{
      backgroundColor: STATUS_COLORS[Number(status)] || "#6c757d",
      color: "#fff",
      fontSize: "11px",
      fontWeight: 600,
      padding: "4px 14px",
      borderRadius: "999px",
      lineHeight: 1,
      whiteSpace: "nowrap",
    }}
  >
    {PAYROLL_STATUS_LABELS[Number(status)] || "Unknown"}
  </span>
);

const getColumns = (handleView, handleDownload, downloadingId) => [
  {
    label: "Employee",
    field: "employee_name",
    className: "fw-semibold",
    sortable: true,
    render: (row) => <UserInfoCell name={row.employee_name} employeeId={row.employee_code} token={row.userToken} />,
  },
  {
    label: "Pay Basis",
    field: "pay_basis",
    sortable: true,
  },
  {
    label: "Period",
    field: "period_label",
    sortable: true,
    render: (row) => formatDisplayPeriod(row.period_start, row.period_end),
  },
  {
    label: "Units Worked",
    field: "units_worked",
    className: "text-end",
    sortable: true,
    render: (row) => `${Number(row.units_worked || 0).toFixed(2)} ${UNIT_LABEL[row.pay_basis] || ""}`,
  },
  {
    label: "Total Income",
    field: "total_income",
    className: "text-end",
    sortable: true,
    render: (row) => `₹${Number(row.total_income || 0).toFixed(2)}`,
  },
  {
    label: "Deduction",
    field: "deduction",
    className: "text-end",
    sortable: true,
    render: (row) => `₹${Number(row.deduction || 0).toFixed(2)}`,
  },
  {
    label: "Net Pay",
    field: "net_pay",
    className: "fw-semibold text-end",
    sortable: true,
    render: (row) => `₹${Number(row.net_pay || 0).toFixed(2)}`,
  },
  {
    label: "Status",
    field: "status",
    className: "text-center",
    sortable: false,
    render: (row) => (
      <div className="d-flex flex-column align-items-center gap-1">
        <StatusBadge status={row.status} />
        {Number(row.is_hold) === 1 && <span className="badge bg-warning text-dark">On Hold</span>}
      </div>
    ),
  },
  {
    label: "Action",
    field: "action",
    className: "fw-semibold text-center",
    sortable: false,
    render: (row) => (
      <div className="d-flex gap-2 justify-content-center">
        <div className="cursor-pointer text-primary" onClick={() => handleView(row)} title="View / Action">
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            visibility
          </span>
        </div>
        {[PAYROLL_STATUS.GENERATED, PAYROLL_STATUS.APPROVED].includes(Number(row.status)) && (
          <div
            className={downloadingId === row.id ? "text-muted" : "cursor-pointer text-success"}
            style={downloadingId === row.id ? { pointerEvents: "none", opacity: 0.6 } : undefined}
            onClick={() => handleDownload(row)}
            title="Download Payslip"
          >
            <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
              {downloadingId === row.id ? "hourglass_empty" : "download"}
            </span>
          </div>
        )}
      </div>
    ),
  },
];

export default getColumns;
